
/**
 * api接口的统一出口
 */
// 导入api模块 (在此引入API模块 并在下面导出)
import publicApi from '@/api/publicApi'

export default {
    publicApi
}
